module.exports = "/_next/static/images/8e8e77f859af0ff861b612579315ddc7-apple-screen.png";